/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PermissionScope = {
    None: 'None',
    User: 'User',
    TeamMember: 'TeamMember',
    TeamManager: 'TeamManager'
} as const;
export type PermissionScope = typeof PermissionScope[keyof typeof PermissionScope];


export function PermissionScopeFromJSON(json: any): PermissionScope {
    return PermissionScopeFromJSONTyped(json, false);
}

export function PermissionScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionScope {
    return json as PermissionScope;
}

export function PermissionScopeToJSON(value?: PermissionScope | null): any {
    return value as any;
}

